import { SortableItemContainerComponent } from "@/Common/Components/Collections/SortableItemContainer";
import { MedicalItemAlertsAndSpecialNeeds } from "@/Patient/Models/MedicalSummary/MedicalItemAlertsAndAllergies";

class SortableContainerForAlerts extends SortableItemContainerComponent<MedicalItemAlertsAndSpecialNeeds> { }

export { SortableContainerForAlerts };
